import { tabCloser, tabTemplate, categoryTab } from '@/layout/state/state';
import { matchSingleUrl } from '@/constants/urls';
import { closeRoles } from '../actions';
import RolesActions from '../containers/RolesActions';
import RolesPanel from '../components/RolesPanel';

export default {
  ...tabTemplate('roles', RolesPanel, matchSingleUrl(['roles']), RolesActions),
  ...tabCloser('closeRolesTab', closeRoles),
  access: ({ roles }) => roles.read,
  componentState: ({ url }) => categoryTab(url, 'all'),
  order: 700,
  position: 'bottom-right',
  icon: 'fas fa-list-alt',
  dropDownIcon: 'list alternate',
};
